import React, { useEffect, useRef } from "react";
import { loadGoogle, COUNTRIES } from "../lib/googleMaps";

// Google Places Autocomplete input. Calls onSelect({label, lat, lng}) on choose.
const AddressAutocomplete = ({ value, onChange, onSelect, placeholder, className, icon: Icon }) => {
  const inputRef = useRef(null);
  const acRef = useRef(null);

  useEffect(() => {
    let active = true;
    loadGoogle()
      .then((g) => {
        if (!active || !inputRef.current || acRef.current) return;
        acRef.current = new g.maps.places.Autocomplete(inputRef.current, {
          fields: ["geometry", "formatted_address", "name"],
          componentRestrictions: { country: COUNTRIES },
        });
        acRef.current.addListener("place_changed", () => {
          const place = acRef.current.getPlace();
          if (place && place.geometry && place.geometry.location) {
            const label = place.formatted_address || place.name;
            onSelect({
              label,
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            });
            if (onChange) onChange(label);
          }
        });
      })
      .catch(() => {});
    return () => { active = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative">
      {Icon && <Icon size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#9CA0B0] pointer-events-none z-10" />}
      <input
        ref={inputRef}
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        placeholder={placeholder}
        className={className}
      />
    </div>
  );
};

export default AddressAutocomplete;
